<template>
    <v-dialog-old ref="dialog" id="medflexDoctor" :overflow="true">
        <fieldset disabled>
            <legend>Врач МЕДФЛЕКС</legend>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 140px; color: #666;">doctor_id</span>
                <input :value="M.medflex_id" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 140px; color: #666;">ФИО</span>
                <input :value="M.name" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 140px; color: #666;">Специальность</span>
                <input :value="M.specialities" readonly/>
            </span>
        </fieldset>

        <fieldset style="overflow: visible;">
            <legend>Врач ДОКТУ</legend>
            <div v-if="M.doctor"
                 class="textarea"
                 style="position: relative; background-color: #f8f8f8 !important;">
                <span>{{ M.doctor.fullname }}</span>
                <br>
                <small>{{ M.doctor.specialitiesAsText }}</small>
                <br>
                <a :href="M.doctor.fullUrl" target="_blank">{{ M.doctor.fullUrl }}</a>
                <button class="tiny redHover" @click.prevent="M.doctor = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
            <v-select v-else-if="!selectedDoctor"
                      v-on:remove="selectDoctor"
                      :options="foundDoctors"
                      @search-change="findDoctors"
                      :internal-search="false"
                      placeholder="Введите ФИО или URL ДОКТУ">
                <template v-slot="{ option }">
                    <div class="textarea" >
                        <span>{{ option.fullname }}</span>
                        <br>
                        <small>{{ option.specialitiesAsText }}</small>
                        <br>
                        <small>{{ option.fullUrl }}</small>
                    </div>
                </template>
            </v-select>
            <div v-else class="textarea" style="position: relative;">
                <span>{{ selectedDoctor.fullname }}</span>
                <br>
                <small>{{ selectedDoctor.specialitiesAsText }}</small>
                <br>
                <a :href="selectedDoctor.fullUrl" target="_blank">{{ selectedDoctor.fullUrl }}</a>
                <button class="tiny redHover" @click.prevent="selectedDoctor = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
        </fieldset>

        <template v-slot:footer>
            <v-loading-component @click="save">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: !M.doctor && selectedDoctor}, loadingClass]"
                            :disabled="M.doctor || !selectedDoctor">
                        Сохранить
                    </button>
                </template>
            </v-loading-component>
        </template>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            M: {
                id: null,
                medflex_id: null,
                name: null,
                specialities: null,
                doctor: null,
            },
            foundDoctors: [],
            selectedDoctor: null,
            clinicId: null,
            doctorSearchRequest: null,
        };
    },
    methods: {
        resetData(clinicId = null) {
            this.M = {
                id: null,
                medflex_id: null,
                name: null,
                specialities: null,
                doctor: null,
            };
            this.foundDoctors = [];
            this.selectedDoctor = null;
            this.clinicId = clinicId;
            this.doctorSearchRequest = null;
        },
        show(id, clinicId) {
            this.resetData(clinicId);

            return this.axios.get('onlineAppointments/doctor/' + id + '/read').then(response => {
                Object.assign(this.M, response.data);
                this.$refs.dialog.show();
            });
        },
        save(btn) {
            if (this.M.doctor || !this.selectedDoctor) {
                return;
            }

            btn.startLoadingAnimation();

            this.axios.post('onlineAppointments/doctor/' + this.M.id + '/save', {
                doctor_id: this.selectedDoctor.id,
            }).then(response => {
                btn.stopLoadingAnimation();
                this.$emit('updated');
                this.$refs.dialog.hide();
            }).catch(response => {
                if (response.status === 'error') {
                    this.$modal('Этот врач уже был связан', {
                        name: 'ОК',
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, {
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, false, 'only-text-dialog');
                }
            });
        },
        findDoctors(query) {
            if (this.doctorSearchRequest) {
                this.doctorSearchRequest.cancel();
            }

            if (query.length > 2) {
                this.doctorSearchRequest = this.axios.CancelToken.source();

                this.axios.post('/doctorsAutocomplete', {
                    q: query,
                    filter: {
                        clinic_id: this.clinicId,
                    }
                }, {
                    cancelToken: this.doctorSearchRequest.token
                }).then(res => {
                    this.foundDoctors = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.fullname,
                            fullname: item.data.fullname,
                            specialitiesAsText: item.data.specialitiesAsText,
                            fullUrl: item.data.fullUrl,
                        }
                    });
                }).catch(() => {})
            } else {
                this.foundDoctors = [];
            }
        },
        selectDoctor(payload) {
            this.selectedDoctor = {
                id: payload.id,
                fullname: payload.fullname,
                specialitiesAsText: payload.specialitiesAsText,
                fullUrl: payload.fullUrl,
            };

            this.foundDoctors = [];
        },
    },
}
</script>

<style>
#medflexDoctor {
    overflow: visible;
}
</style>
